module.exports = __webpack_public_path__ + "media/images/no-locations-2f8dbb79f2064a368d1b1db971d4282d.svg";